/*
 * why not use promise style ?
 * 1. DB is not free of side effect. it will show post success and error popup
 *    depending on the callback returnValue
 * 2. stream makes you to return value in every resolve, which could be annoying
 * 3. promise only support one param to pass on, where jquery ajax has three
 * 4. onRejected without throwing another error, will enter onResolved at next then,
 *    which will be confusing, since most of the time, we can't handle the error
 *    at the first onRejected
 * we will just stick to callback style
 * */

import $ from 'jquery'
import {
  Message
} from 'iview'
import storage from '@/common/storage'

function getXToken() {
  return storage.get('X-TOKEN');
}

function noop() {}

const DB = {},
  tokenHeader = (['test', 'local', 'tdc3'].every((v) => {
    return location.host.indexOf(v) == -1
  })) ? 't' : 't-test';

//DB.prefix = 'http://192.168.50.32:6981/hr-web';
DB.prefix = '/hr-web/';
DB.mock_url = 'http://108.61.75.202:3000/mock/11/';

DB.tokenHeader = tokenHeader;

DB.getHeaders = () => {
  return {
    'X-TOKEN': getXToken()
  }
};

DB.getTokenMap = () => {
  return {
    [tokenHeader]: getXToken()
  };
};

DB.request = function (opts = {}) {
  const {
    url,
    type = 'get',
    data,
    successText = '',
    showMessage = true,
    headers = {},
    cache = false,
    success = noop,
    error = noop,
    complete = noop,
    redirectWhenNotLogin = true,
    // withLoginInfo = true,
    jsonp = false
  } = opts;

  const token = getXToken();
  if (token) {
    headers[tokenHeader] = token;
  }



  return $.ajax({
    url,
    data,
    headers,
    cache,
    method: type.toUpperCase(),
    dataType: jsonp ? 'jsonp' : 'json',
    success(data, statusText, xhr) {
      if (!jsonp && !data.success) {
        if (redirectWhenNotLogin && (data.errCode == '15006' || data.errCode == '100004')) {
          //storage.clear();
          location.href = `/index.html#/?url=${encodeURIComponent(location.href)}`;
          return;
        }
        const ret = error(data);
        if (ret !== false) {
          Message.error({
            content: data.message || '网络繁忙'
          });
        }
        complete(data);
        return;
      }
      const ret = success(data);
      complete(data);
      if (showMessage && data.success && type.toUpperCase() == 'POST' && !url.includes('/im/')) {
        Message.success({
          content: successText || data.message || '操作成功',
          duration: 3
        })
      }
    },
    error(xhr, statusText, errorThrown) {
      var data = {
        success: false,
        msg: '网络繁忙'
      };
      if (xhr.status == 401 && redirectWhenNotLogin) { // not login
        location.href = `/index.html#/?url=${encodeURIComponent(location.href)}`;
        return;
      }

      if (statusText === 'abort') {
        return;
      }
      console.log(errorThrown);
      if (errorThrown == 'Unauthorized') {
        data = {
          success: false,
          msg: '您没有访问权限，请重新登录'
        };
      };

      const ret = error(data);
      if (ret !== false) {
        Message.error({
          content: data.message || '网络繁忙'
        });
      }
      complete(data);
    }
  });
};

DB.getToken = () => {
  return getXToken();
};

export default DB



// WEBPACK FOOTER //
// ./src/common/db.js